import React from "react";
import "./App.css";
import AccesoCamara from "./components/accesoCamara/AccesoCamara";

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <h1>Vista terapia</h1>
        <p className="app-lead">
          Acceso para representantes: use el código enviado por correo al
          confirmar la cita. La transmisión está disponible durante los 59
          minutos desde la hora de inicio.
        </p>
      </header>
      <main className="app-main">
        <AccesoCamara />
      </main>
    </div>
  );
}

export default App;
